import { inject, Injectable } from '@angular/core';
import { TosDocumentModel, UserModel } from '@libs/account/models';
import { Observable } from 'rxjs';
import { ConnectorService } from '../connector';

@Injectable({
  providedIn: 'root',
})
export class UserRepositoryService {
  private readonly connector: ConnectorService = inject(ConnectorService);

  public read(): Observable<UserModel | undefined> {
    return this.connector.connect('user', 'user');
  }

  public update(data: Partial<UserModel>): Observable<UserModel | undefined> {
    return this.connector.connect('user', 'userUpdate', { payload: data });
  }

  public delete(data: Partial<UserModel>): Observable<UserModel | undefined> {
    return this.connector.connect('user', 'userDelete', { payload: data });
  }

  public checkTos(appId: string): Observable<TosDocumentModel | undefined> {
    return this.connector.connect<TosDocumentModel | undefined>('user', 'tosCheck', {
      searchParams: { appId },
    });
  }

  public currentTos(appId: string): Observable<TosDocumentModel | undefined> {
    return this.connector.connect<TosDocumentModel | undefined>('user', 'tosCurrent', {
      searchParams: {
        appId,
      },
    });
  }

  public consentTos(tosId: string): Observable<void> {
    return this.connector.connect<void>('user', 'tosConsent', {
      searchParams: { tosId },
    });
  }
}
